import getImageHeight from "./getImageHeight";
import { UmbracoImage, UmbracoImageCrop } from "../models/media.interface";
import imageData from "./imageData";
import urlBuilder from "app/umbraco/helpers/urlBuilder";

type Size = { desktop: number; tablet: number; mobile: number };

const setImageOptionsUmbraco = (
  image: any,
  imageCrop?: UmbracoImageCrop,
  width?: Size,
  height?: Size
): string[] => {
  if (!image) return [];

  const imageUrl = urlBuilder(image);
  const params = new URLSearchParams();

  const calculateSize = (size: Size, device: string): number => {
    return size[device];
  };

  const imageUrlsWithOptions = imageData.map((data) => {
    const imageWidth = width
      ? calculateSize(width, data.device)
      : imageCrop
      ? data.width
      : Number(image.width) * data.multiplier;
    const imageHeight = height
      ? calculateSize(height, data.device)
      : imageCrop || width
      ? getImageHeight(
          imageWidth,
          imageCrop?.width ?? Number(image.width),
          imageCrop?.height ?? Number(image.height)
        )
      : Number(image.height) * data.multiplier;

    params.set("width", `${imageWidth}`);
    params.set("height", `${imageHeight}`);

    // Image Focal Point Params
    if (image.focalPoint) {
      params.set("rxy", `${image.focalPoint.left},${image.focalPoint.top}`);
      params.set("rmode", "crop");
    } 
    // else if (imageCrop?.coordinates) {
    //   params.set(
    //     "cc",
    //     `${imageCrop.coordinates.x1},${imageCrop.coordinates.y1},${imageCrop.coordinates.x2},${imageCrop.coordinates.y2}`
    //   );
    // } 
    else {
      params.set("rxy", `${0.5},${0.5}`);
    }

    params.set("quality", "80");

    if (data.type === "image/webp") {
      params.set("format", "webp");
    } else {
      params.delete("format");
    }

    const querySeparator = imageUrl.toString().indexOf("?") > 0 ? "&" : "?";
    return `${imageUrl}${querySeparator}${params.toString()}`;
  });

  return imageUrlsWithOptions;
};

export default setImageOptionsUmbraco;
